import React from 'react';

export const CloseCircleIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="42.426" height="42.426" viewBox="0 0 42.426 42.426"><path style={{fill: '#888'}} d="M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm8.929,16.786H16.786v7.143H13.214V16.786H6.071V13.214h7.143V6.071h3.571v7.143h7.143Z" transform="translate(0 21.213) rotate(-45)"/></svg>
    )
}